<!-- <a href="product/{{fabricORfinished}}/{{productListingData.product.slug}}/{{productListingData.id}}" target="_blank"> -->

<div class="product_item_ind_cont" *ngIf="productListingData">

	<a routerLink="/product/{{fabricORfinished}}/{{productListingData.product.slug}}" target="_blank">
		<div class="similar_products" *ngIf="productListingData.product.specialStatus">
			{{productListingData.product.specialStatus.name}}
		</div>
		<div class="img_cont" (mouseenter)="changeHeroToHoverImage('onover')"
			(mouseleave)="changeHeroToHoverImage('out')">

			<!-- TODO: do not remove. this is for lazy load image -->
			<!-- <img class="forground" loading="lazy" alt="hero image"
				[lazyLoad]="this.productListingData.product.heroImage"
				[defaultImage]="'./assets/img/default_image_listing.png'" />

			<img class="overlayImage" [@enterAnimation] *ngIf="hoverActive"
				[lazyLoad]="this.productListingData.product.hoverImage"
				[defaultImage]="'./assets/img/default_image_listing.png'" loading="lazy" alt="hover image" /> -->
			<!-- TODO: do not remove. this is for lazy load image. -->

				<img class="forground"  alt="hero image"
				src="{{productListingData.product.heroImage}}"/>

				<img class="overlayImage" [@enterAnimation] *ngIf="hoverActive"
				src="{{this.productListingData.product.hoverImage}}"
				 alt="hover image" />

			<img class="overlayImage" [@enterAnimation] *ngIf="mockupFabricImage" src="{{mockupFabricImage}}" loading="lazy" alt="Fabric mockup image" />

		</div>
	</a>

	<!-- fabric only start for desktop -->
	<ng-container *ngIf="!isMobile">
		<a routerLink="/product/{{fabricORfinished}}/{{productListingData.product.slug}}" >
			<div class="for_fabric_image_cont for_desktopp" *ngIf="productListingData.product.fabricProfile">
				<ng-container *ngFor="let fabricProfile of fabricProfileItemList">
					<img [lazyLoad]="this.fabricProfile.fabricPreview.heroImage" class="active" loading="lazy"
						alt="{{fabricProfile.mockupText}}" (mouseenter)="showMockupImages(this.fabricProfile.mockupImage)" (mouseleave)="hideMockupImages()" />
				</ng-container>
				<div class="fabric_more_count" *ngIf="reatOffabricProfileItemList.length!=0" (click)="preventDefaultBehaviour($event)">
					+{{reatOffabricProfileItemList.length}}
				</div>

				<div class="more_fabric_inner craft_wrapper">
					<ng-container *ngFor="let fabricProfile of reatOffabricProfileItemList">
						<img [lazyLoad]="this.fabricProfile.fabricPreview.heroImage" class="active" loading="lazy"
							alt="{{fabricProfile.mockupText}}" (mouseenter)="showMockupImages(this.fabricProfile.mockupImage)" (mouseleave)="hideMockupImages()" />
					</ng-container>
				</div>
			</div>
		</a>
	</ng-container>
	<!-- fabric only for desktop end -->



	<!-- fabric only for mobile start -->

	<ng-container *ngIf="isMobile">
		<div class="for_fabric_image_cont for_mobile" *ngIf="productListingData.product.fabricProfile" >
			<ng-container *ngFor="let fabricProfile of fabricProfileItemList">
				<img src="{{this.fabricProfile.fabricPreview.heroImage}}" class="active" loading="lazy"
					alt="{{fabricProfile.mockupText}}" (mouseenter)="showMockupImages(this.fabricProfile.mockupImage)" (mouseleave)="hideMockupImages()" />
			</ng-container>
			<div class="fabric_more_count" *ngIf="reatOffabricProfileItemList.length!=0" (click)="preventDefaultBehaviour($event)">
				+{{reatOffabricProfileItemList.length}}
			</div>

			<div class="more_fabric_inner craft_wrapper">
				<ng-container *ngFor="let fabricProfile of reatOffabricProfileItemList">
					<img src="{{this.fabricProfile.fabricPreview.heroImage}}" class="active" loading="lazy"
						alt="{{fabricProfile.mockupText}}" (mouseenter)="showMockupImages(this.fabricProfile.mockupImage)" (mouseleave)="hideMockupImages()" />
				</ng-container>
			</div>
		</div>
	</ng-container>
	<!-- fabric only for mobile end -->



	<div class="listing_item_info">
		<div class="flex justify-center items-center gap-3">
			<a routerLink="/product/{{fabricORfinished}}/{{productListingData.product.slug}}">
			<p class="name">
				{{productListingData.product.name| truncketHtml:20}}
			</p>

			<p class="price">
				{{selectedCurrency}}
				{{productListingData.product.price | currencyConverter | number: '1.0-2'}} /
				{{productListingData.product.unit}}
			</p>
		</a>
			<div (click)="toggleWishlist()" class="fb-wishlist-icon cursor-pointer">
				<img *ngIf="!productListingData.inWishlist" src="assets/img/non-favourite.svg" alt="">
				<img *ngIf="productListingData.inWishlist" src="assets/img/favourite.svg" alt="">
			</div>
		</div>

		<div class="login_for_bulk_price" *ngIf="!isLoggin" [routerLink]="['../../auth/login']" (click)="storeUrl()">
			<p>Login For Bulk Price</p>
			<span class="material-symbols-outlined"> person </span>
		</div>
		<div class="login_for_bulk_price loggedIn" *ngIf="isLoggin && maxDiscount!=0">
			<p>Bulk Order &#64; {{productListingData.product.bulkDiscountedPrice! | currencyConverter | number: '1.0-2'}} / {{productListingData.product.unit}}
			</p>
		</div>
	</div>

	<div class="circle_image_cont">
		<ng-container *ngFor="let relatedProductList of relatedProductList">
			<a routerLink="/product/{{fabricORfinished}}/{{relatedProductList.slug}}">
				<!-- <span style="background-image: url({{relatedProductList.heroImage}});"></span> -->
				<span>
					<img [lazyLoad]="relatedProductList.heroImage" />
				</span>

			</a>
		</ng-container>
		<a routerLink="/product/{{fabricORfinished}}/{{productListingData.product.slug}}">
			<div class="fabric_more_count for_related_product" *ngIf="excenRelatedProductList.length!=0">
				+{{excenRelatedProductList.length}}
			</div>
		</a>
	</div>
</div>
